import dynamic from 'next/dynamic';

import { ContentTilesSectionProps } from '../../../components/sections/ContentTilesSection';
import { SectionRenderer } from '../../../types/Section';
import { Transformer } from '../../../types/Transformer';
import { ContentTilesSectionContent } from './types';
import { validateNumberOfTiles } from './validation';

/* istanbul ignore next */
export const renderer: SectionRenderer<ContentTilesSectionProps> =
  dynamic<ContentTilesSectionProps>(() =>
    import('../../../components/sections/ContentTilesSection').then(
      (mod) => mod.ContentTilesSection,
    ),
  );

export const transformer: Transformer<ContentTilesSectionContent, ContentTilesSectionProps> = ({
  _metadata,
  items,
  tracking_title,
}) => ({
  uid: _metadata.uid,
  props: {
    tiles: items.map(({ title, url, image, featured_product_code, tile_background_color }) => ({
      title,
      href: url,
      imageSrc: image.url,
      ...(tile_background_color.custom_background_color && {
        backgroundColor: tile_background_color.background_color,
      }),
      ...(featured_product_code ? { featuredProductCode: featured_product_code } : {}),
    })),
    trackingTitle: tracking_title,
  },
  errors: validateNumberOfTiles(items.length),
});
